/**
 * Class for unit conversions.
 * @class Convert
 * @return Object
 */
var Convert = function () {
    return {
        /*--------------------------------------------
            PRESSURE DROP CONVERSION
        --------------------------------------------*/

        /**
         * Converts the pressure drop value from MMH20
         * to Pascals
         * @param {Float} pd
         * @returns {Float} pd in pascals 
         */
        toPascals: function(pd) {
            pd = parseFloat(pd);        
            if (isNaN(pd)) {
                return 0;
            }
            return pd * 9.80634;
        },


        /**
         * Converts the pressure drop value from Pascals
         * to MMH20
         * @param {Float} pd 
         * @returns {Float} pd in MMH2O
         */
        toMMH2O: function(pd) {
            pd = parseFloat(pd);        
            if (isNaN(pd)) {
                return 0;
            }
            return pd / 9.80634;
        },


        /*--------------------------------------------
            WEIGHT CONVERSIONS
        --------------------------------------------*/

        /**
         * Converts Grams per 100 to Milligrams
         * @param {Float} weight
         * @returns {Float} Milligrams
         */
        fromG100toMG: function(weight) {
            weight = parseFloat(weight);
            if (isNaN(weight)) {
                return 0;
            }
            return weight * 10;
        },

        /**
         * Converts Grams per 100 to Grams
         * @param {Float} weight
         * @returns {Float} Grams 
         */
        fromG100toG: function(weight) {
            weight = parseFloat(weight);
            if (isNaN(weight)) {
                return 0;
            }
            return weight / 100;
        },


        /**
         * Converts Milligrams to Grams per 100
         * @param {Float} weight 
         * @returns {Float} Grams per 100
         */
        fromMGtoG100: function(weight) {
            weight = parseFloat(weight);
            if (isNaN(weight)) {
                return 0;
            }
            return weight / 10;
        },


        /**
         * Converts Grams to Grams per 100
         * @param {Float} weight 
         * @returns {Float} Grams per 100
         */
        fromGtoG100: function(weight) {
            weight = parseFloat(weight);
            if (isNaN(weight)) {
                return 0;
            }
            return weight * 100;
        },


        /*--------------------------------------------
            SIZE CONVERSION
        --------------------------------------------*/

        /**
         * Converts circumference value to diameter
         * @param {Float} circumference 
         * @returns {Float} diameter
         */
        toDiameter: function(circumference) {
            circumference = parseFloat(circumference) || 0;
            if (isNaN(circumference)) {
                return 0;
            }
            return parseFloat((circumference / Math.PI).toFixed(2));
        },

        /**
         * Converts diameter value to circumference
         * @param {Float} diameter 
         * @returns {Float} circumference
         */
        toCircumference: function(diameter) {
            diameter = parseFloat(diameter) || 0;
            if (isNaN(diameter)) {
                return 0;
            }
            return parseFloat((diameter * Math.PI).toFixed(2));
        },


        /*--------------------------------------------
            PLASTICIZER CONVERSIONS
        --------------------------------------------*/

        /**
         * Converts plasticizer wetbasis value to drybasis
         * @param {Float} pz 
         * @returns {Float} PZ dry basis 
         */
        toDryBasis: function(pz) {
            pz = parseFloat(pz);
            if (isNaN(pz)) {
                return 0;
            }

            return pz / (100 - pz) * 100;
        },

        /**
         * Converts plasticizer drybasis value to wetbasis
         * @param {Float} pz 
         * @returns {Float} PZ wetbasis
         */
        toWetBasis: function(pz) {
            pz = parseFloat(pz);
            if (isNaN(pz)) {
                return 0;
            } 
            return pz / (100 + pz) * 100;
        }
    };
};

export default Convert();


// WEBPACK FOOTER //
// ./src/convert.js